import axios from "./instance";

const API_URL = process.env.NEXT_PUBLIC_API_LINK;

export const getAllDepartments = async () => {
  try {
    const res = await axios.get(
      `http://localhost:8000/api/departments/allDepartments`
    );
    return res?.data;
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};

export const getDepartmentByID = async (adminId) => {
  try {
    const res = await axios.get(
      `http://localhost:8000/api/departments/getDepartmentsByAdminId/${adminId}`
      
    );
    return res?.data;
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};

export const createDepartment = async (departmentData) => {
  try {
    const res = await axios.post(
      `http://localhost:8000/api/departments/createDepartment`,
      departmentData
    );
    return res.data;
  } catch (error) {
    console.error("Error creating department:", error);
    throw error;
  }
};

export const updateDepartment = async (departmentID, departmentData) => {
  try {
    const res = await axios.patch(
      `http://localhost:8000/api/departments/updateDepartment/${departmentID}`,
      departmentData
    );
    return res.data;
  } catch (error) {
    console.error(`Error updating department with ID ${departmentID}:`, error);
    throw error;
  }
};

export const deleteDepartment = async (departmentID) => {
  try {
    const res = await axios.delete(
      `http://localhost:8000/api/departments/deleteDepartment/${departmentID}`
    );
    return res.data;
  } catch (error) {
    console.error(`Error deleting department with ID ${departmentID}:`, error);
    throw error;
  }
};
